import useMedia from "hooks/use-media";
import Image from "next/image";
import styles from "./SectionBackgroundProductServiceV2.module.scss";

const SectionBackgroundProductServiceV2 = ({
    imageSrc = null,
    srcUrl = null,
}) => {
    const isSm = useMedia("(max-width: 480px)");
    const getFileImageSrc = () => {
        const src = isSm
            ? "/images/product-services/v2/mobile/cover.png"
            : "/images/product-services/v2/desktop/cover.png";
        return src;
    };

    const imgSrc = getFileImageSrc();

    return (
        <div className={styles.sectionWrap}>
            <div className={`${styles.bgWrap} ${styles.bgTopHome}`}>
                <Image
                    className={`${styles.bgImg}`}
                    src={imgSrc}
                    alt={"product and services"}
                    layout="fill"
                    objectFit="cover"
                    quality={95}
                    loading="lazy"
                />
            </div>
        </div>
    );
};

export default SectionBackgroundProductServiceV2;
